<div class="payment-option-container" (click)="$event.stopPropagation()">
	<form [formGroup]="paymentFormGroup">
		<mat-radio-group class="payment-radio" formControlName="paymentOptionType">
			<!-- Payment Option: Full Price -->
			<div class="payment-radio__btn">
				<mat-radio-button
					[value]="paymentOptionFullPrice"
					[checked]="
						paymentTypeVal == paymentOptionFullPrice &&
						paymentOptionFPTypeVal == paymentOptionRazer
					"
					class="fp-margin"
					(change)="fpRazerSelected($event)"
				>
					<div class="payment-radio__label">
						{{ "common.fullPrice" | translate }}
					</div>

					<div class="payment-radio__bold">
						RM {{ paymentValues.totalAmount | number: "1.2-2" }}
					</div>

					@if (
						this.paymentFormGroup?.value?.paymentOptionType !=
							paymentOptionFullPrice ||
						paymentOptionFPTypeVal == paymentOptionShopee
					) {
						<div>
							<img
								src="/assets/icons/payments/full-price.png"
								alt=""
								class="payment-radio__btn__icon"
							/>
						</div>
					}
				</mat-radio-button>

				@if (
					this.paymentFormGroup?.value?.paymentOptionType ==
						paymentOptionFullPrice &&
					paymentOptionFPTypeVal == paymentOptionRazer
				) {
					<mat-radio-group
						class="payment-radio full-price"
						formControlName="paymentChannel"
					>
						<div class="ml-lg mb-sm mt-md">
							{{ "paymentOptions.paymentMethod" | translate }}
						</div>
						<mat-radio-button [value]="paymentOptionVisa">
							<div>Visa / Mastercard</div>
							<img
								src="/assets/icons/payments/full-price-1.png"
								alt=""
								class="full-price__icon"
							/>
						</mat-radio-button>
						<mat-radio-button [value]="paymentOptionFpx">
							<div>Online Banking (FPX)</div>
							<img
								src="/assets/icons/payments/full-price-2.png"
								alt=""
								class="full-price__icon"
							/>
						</mat-radio-button>
						<mat-radio-button [value]="paymentOptionFpxEnterprise">
							<div>Online Banking (FPX for Enterprise)</div>
							<img
								src="/assets/icons/payments/full-price-2.png"
								alt=""
								class="full-price__icon"
							/>
						</mat-radio-button>
						@if (paymentChannelVal == paymentOptionFpxEnterprise) {
							<mat-form-field class="e-wallet-form">
								<mat-label>
									{{ "paymentOptions.selectFpxEnterpriseBank" | translate }}
								</mat-label>
								<mat-select
									disableOptionCentering
									required
									formControlName="fpxEnterpriseType"
								>
									@for (item of fpxEnterpriseTypeListing; track item) {
										<mat-option [value]="item?.value">
											<span class="ewallet-options">
												<img [src]="item?.img" alt="" />
												{{ item?.name }}
											</span>
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
						}
						<mat-radio-button [value]="paymentOptionEwallet">
							<div>e-Wallet</div>
							<img
								src="/assets/icons/payments/full-price-3.png"
								alt=""
								class="full-price__icon"
							/>
						</mat-radio-button>
						@if (paymentChannelVal == paymentOptionEwallet) {
							<mat-form-field class="e-wallet-form">
								<mat-label>
									{{ "paymentOptions.selectEWallet" | translate }}
								</mat-label>
								<mat-select
									disableOptionCentering
									required
									formControlName="ewalletType"
								>
									@for (item of ewalletTypeListing; track item) {
										<mat-option [value]="item?.value">
											<span class="ewallet-options">
												<img [src]="item?.img" alt="" />
												{{ item?.name }}
											</span>
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
						}
					</mat-radio-group>
				}
			</div>

			<!-- Atome BNPL -->
			<mat-radio-button
				[value]="paymentOptionBNPL"
				[checked]="
					this.paymentFormGroup?.value?.paymentOptionType == paymentOptionAtome
				"
				class="payment-radio__btn"
				(change)="fpAtomeSelected($event)"
			>
				<div class="payment-radio__label">{{ "common.atome" | translate }}</div>
				<div class="mt-xs">
					<span>
						<div
							class="payment-radio__label"
							style="white-space: normal !important"
							[innerHTML]="'common.atomeBNPL' | translate"
						></div>
					</span>
				</div>
				<div class="shopback-description mt-sm">
					<img
						src="/assets/icons/payments/AtomeBNPL.png"
						alt=""
						class="shopback-icon"
					/>
				</div>
			</mat-radio-button>

			<mat-radio-button
				[value]="paymentOptionFullPrice"
				[checked]="
					this.paymentFormGroup?.value?.paymentOptionType ==
						paymentOptionFullPrice &&
					paymentOptionFPTypeVal == paymentOptionShopee
				"
				class="payment-radio__btn"
				(change)="fpShopeeSelected($event)"
			>
				<div class="payment-radio__label">SPayLater / ShopeePay</div>
				<div class="mt-xs">
					<span class="payment-radio">
						{{ "paymentOptions.ScanQRAndChooseInstalmentsUp" | translate }}
						<br />
						{{ "paymentOptions.to12Months" | translate }}.
					</span>
				</div>
				<div class="mt-sm">
					<img
						src="/assets/icons/spaylater_spay.png"
						alt=""
						class="shopee-icon"
					/>
				</div>
			</mat-radio-button>

			<!-- Grab Pay -->
			<mat-radio-button
				[value]="paymentOptionFullPrice"
				[checked]="
					this.paymentFormGroup?.value?.paymentOptionType ==
						paymentOptionFullPrice &&
					paymentOptionFPTypeVal == paymentOptionGrab
				"
				class="payment-radio__btn"
				(change)="fpGrabSelected($event)"
			>
				<div class="payment-radio__label">GrabPay / PayLater by Grab</div>
				<div class="mt-xs">
					<span
						class="payment-radio bold"
						[innerHtml]="'paymentOptions.grabPayDesc' | translate"
					></span>
				</div>
				<div class="mt-sm">
					<img
						src="/assets/icons/payments/grabpay.png"
						alt=""
						class="grab-icon"
					/>
				</div>
			</mat-radio-button>

			<!-- Shopback : hidden on production only) -->
			@if (showShopback) {
				<mat-radio-button
					[value]="paymentOptionShopback"
					[checked]="
						this.paymentFormGroup?.value?.paymentOptionType ==
						paymentOptionShopback
					"
					class="payment-radio__btn"
					(change)="fpShopbackSelected($event)"
				>
					<div class="payment-radio__label">
						{{ "common.shopback" | translate }}
					</div>
					<div class="mt-xs">
						<span class="payment-radio__bold"
							>RM {{ paymentValues.shopbackTotalAmount | number: "1.2-2" }}</span
						>
					</div>
					<div class="shopback-description mt-sm">
						<span class="bold">Pay</span> and get
						<span class="bold orange-text">Cashback </span>
						<img src="/assets/icons/shopback.png" alt="" class="shopback-icon" />
					</div>
				</mat-radio-button>
			}

			@if (showEPP3Or6Or12Months) {
				<mat-radio-button
					[value]="paymentOptionEPP3Or6Or12Months"
					[checked]="
						this.paymentFormGroup?.value?.paymentOptionType ==
						paymentOptionEPP3Or6Or12Months
					"
					class="payment-radio__btn"
					(change)="epp3Or6Or12MonthsSelected($event)"
				>
					<div class="payment-radio__label">
						{{ "paymentOptions.3or6or12" | translate }}
					</div>
					<div class="mt-xs">
						<span class="bold">{{ "paymentOptions.epp" | translate }}</span>
						<span class="gap"></span>
						<img
							src="/assets/icons/payments/rms.png"
							alt=""
							class="payment-radio__btn__icon"
						/>
					</div>
					<img
						src="https://storage.googleapis.com/dev-ps-asset/payment_bank_logos/razer-banks.png"
						alt=""
						class="razer-banks"
					/>
					@if (
						this.paymentFormGroup?.value?.paymentOptionType ==
						paymentOptionEPP3Or6Or12Months
					) {
						<div class="payment-radio__btn__epp">
							<mat-form-field>
								<mat-label>{{
									"paymentOptions.cardIssuer" | translate
								}}</mat-label>
								<mat-select disableOptionCentering formControlName="bank">
									@for (item of epp3Or6Or12MonthsListing; track item) {
										<mat-option [value]="item?.bankName" class="epp-options">
											<span class="ewallet-options">
												<img [src]="item?.bankLogoUrl" alt="" />
												{{ item?.bankName }}
											</span>
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
							@if (paymentFormGroup.controls.bank.value) {
								<mat-form-field>
									<mat-label>{{
										"paymentOptions.monthlyOption" | translate
									}}</mat-label>
									<mat-select
										disableOptionCentering
										formControlName="installmentMonth"
									>
										@for (option of installmentOptions; track option) {
											<mat-option
												[value]="option.installmentPeriod"
												class="epp-options"
											>
												{{
													getPaymentMonthLabel(option.installmentPeriod)
														| translate
												}}
												(<span class="epp-options__bold">
													RM {{ option.installmentAmount | number: "1.2-2" }}
												</span>
												{{ "common.perMonth" | translate }})
											</mat-option>
										}
									</mat-select>
								</mat-form-field>
							}
						</div>
					}
				</mat-radio-button>
			}
			@if (showEPP6Or12Months) {
				<mat-radio-button
					[value]="paymentOptionEPP6Or12Months"
					[checked]="
						this.paymentFormGroup?.value?.paymentOptionType ==
						paymentOptionEPP6Or12Months
					"
					class="payment-radio__btn"
					(change)="epp6Or12MonthsSelected($event)"
				>
					<div class="payment-radio__label">
						{{ "paymentOptions.6or12" | translate }}
					</div>
					<div class="mt-xs">
						<span class="bold">{{ "paymentOptions.epp" | translate }}</span>
						<span class="gap"></span>
						<img
							src="/assets/icons/payments/payex.png"
							alt=""
							class="payment-radio__btn__icon"
						/>
					</div>
					<div class="mt-xs">
						<img
							src="https://storage.googleapis.com/dev-ps-asset/payment_bank_logos/payex-banks.png"
							alt=""
							class="payex-banks"
						/>
					</div>
					@if (
						this.paymentFormGroup?.value?.paymentOptionType ==
						paymentOptionEPP6Or12Months
					) {
						<div class="payment-radio__btn__epp">
							<mat-form-field>
								<mat-label>{{
									"paymentOptions.cardIssuer" | translate
								}}</mat-label>
								<mat-select disableOptionCentering formControlName="bank">
									@for (item of epp6Or12MonthsListing; track item) {
										<mat-option [value]="item?.bankName" class="epp-options">
											<span class="ewallet-options">
												<img [src]="item?.bankLogoUrl" alt="" />
												{{ item?.bankName }}
											</span>
										</mat-option>
									}
								</mat-select>
							</mat-form-field>
							@if (paymentFormGroup.controls.bank.value) {
								<mat-form-field>
									<mat-label>{{
										"paymentOptions.monthlyOption" | translate
									}}</mat-label>
									<mat-select
										disableOptionCentering
										formControlName="installmentMonth"
									>
										@for (option of installmentOptions; track option) {
											<mat-option
												[value]="option.installmentPeriod"
												class="epp-options"
											>
												{{
													getPaymentMonthLabel(option.installmentPeriod)
														| translate
												}}
												(<span class="epp-options__bold">
													RM {{ option.installmentAmount | number: "1.2-2" }}
												</span>
												{{ "common.perMonth" | translate }})
											</mat-option>
										}
									</mat-select>
								</mat-form-field>
							}
						</div>
					}
				</mat-radio-button>
			}
		</mat-radio-group>
	</form>
</div>
